import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, Skeleton } from '@postcheesy/ui-lib/molecules';
import { Mail, MapPinIcon, PhoneIcon } from 'lucide-react';
import { useMagasins } from '../../api/getMagasin';

export const Succursales: React.FC = () => {
    const { data: magasins, isLoading } = useMagasins();
    const apiUrl = import.meta.env.VITE_API_URL;

    const formatGoogleMapsLink = (address: string, city: string, postalCode: string) => {
        const formattedAddress = `${address}, ${city}, ${postalCode}`.replace(/\s/g, '+');
        return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(formattedAddress)}`;
    };

    return (
        <>
            <CardHeader>
                <CardTitle className="text-4xl serif text-foreground">Boutiques</CardTitle>
            </CardHeader>
            {isLoading && (
                <CardContent className="grid grid-cols-1 gap-4 md:grid-cols-2">
                    {[...Array(6)].map((_, index) => (
                        <Card key={index} className="w-full p-4 flex flex-col sm:flex-row gap-4">
                            <Skeleton className="w-[200px] h-[200px] rounded-md" />
                        </Card>
                    ))}
                </CardContent>
            )}
            <CardContent className="grid grid-cols-1 gap-4 md:grid-cols-2">
                {magasins?.map((s, index) => (
                    <Card key={index} className="w-full p-4 flex flex-col sm:flex-row gap-4">
                        <div className='w-[200px] sm:h-[200px] relative overflow-hidden aspect-ratio-1'>
                            <img
                                src={`${apiUrl}/magasin/${s.id}/image?x=400&imageIndex=1`}
                                alt={s.name}
                                className="absolute inset-0 w-full h-full object-cover"
                                loading="lazy"
                                width={400}
                                height={400}
                            />
                        </div>
                        <div className="flex-1">
                            <div className="flex justify-between">
                                <strong>{s.name}</strong>
                                <a href={formatGoogleMapsLink(s.addresse, s.ville, s.codePostal)} target="_blank" rel="noreferrer" className="text-primary transition-all hover:text-foreground">
                                    <MapPinIcon className="h-6 w-6" />
                                </a>
                            </div>
                            <br />
                            <div className='flex flex-col gap-2'>
                                <p>{s.addresse}</p>
                                <p>{s.ville} {s.codePostal}</p>
                                <a href={`tel:${s.telephone}`} className="text-primary underline flex items-center gap-2 hover:text-foreground">
                                    <PhoneIcon className="h-4 w-4" />
                                    <strong>{s.telephone}</strong>
                                </a>
                                <a href={`mailto:${s.courriel}`} className="text-primary underline flex items-center gap-2 hover:text-foreground">
                                    <Mail className="h-4 w-4" />
                                    <strong>{s.courriel}</strong>
                                </a>
                                <a href={formatGoogleMapsLink(s.addresse, s.ville, s.codePostal)} target="_blank" rel="noreferrer" className="text-primary underline font-bold flex items-center gap-2 hover:text-foreground">
                                    <MapPinIcon className="h-4 w-4" />
                                    Voir sur Google Maps
                                </a>
                            </div>
                        </div>
                    </Card>
                ))}
            </CardContent>
        </>
    );
};

